import React from "react";
import { Image } from "mui-image";

import BG from "../../assets/images/invite-bg.svg";
import MAIN from "../../assets/images/invite-main.webp";
import { Button } from "@mui/material";
import { LoadingWrapper } from "../../utils/helpers";

export default function InviteClaim({
  data = {},
  verifying = false,
  inviteClaimHandler = () => {},
}) {
  return (
    <div className="invite-wrapper">
      <div style={{ backgroundImage: `url(${BG})` }} className="invite-main">
        <Image
          duration={800}
          height="100%"
          width="100%"
          fit="contain"
          src={MAIN}
        />
      </div>
      <div className="invite-content">
        <span className="invite-for">
          Hi,{" "}
          <LoadingWrapper
            style={{ display: "inline", width: "max-content" }}
            loading={verifying}
          >
            <span>{data.name || "Invite To"}</span>
          </LoadingWrapper>
        </span>
        <p className="invite-by">
          <LoadingWrapper
            style={{ display: "inline", width: "max-content" }}
            loading={verifying}
          >
            <span className="invite-by-name">
              {data.invite_by || "Invite By"}
            </span>
          </LoadingWrapper>{" "}
          has exclusively invited you to join{" "}
          <span className="invite-by-name">Dopamine.fit</span>
        </p>
        <div className="invite-btn-wrapper">
          <div className="invite-cutout" />
          <div
            style={{ right: "-2rem", left: "auto" }}
            className="invite-cutout"
          />
          <p className="invite-desc">Start & build your fitness business</p>
          <Button
            disabled={verifying}
            onClick={inviteClaimHandler}
            fullWidth
            variant="contained"
            size="large"
          >
            Claim Your Invite
          </Button>
        </div>
      </div>
    </div>
  );
}
